'use es6';

import http from 'hub-http/clients/apiClient';
export function fetchBrandColors() {
  return http.get(`branding/v1/colors`);
}